import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/axios';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: 'pusher',
  key: 'a4f4710e770a62f29258',
  cluster: 'ap2',
  forceTLS: true,
});

export default function CuisineHome() {
  const { user, logout } = useAuth();
  const [commandes, setCommandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [time, setTime] = useState(new Date());

  const chargerCommandes = () => {
    api.get('/commandes').then((res) => {
      setCommandes(res.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    chargerCommandes();
    const interval = setInterval(chargerCommandes, 3000);
    const clock = setInterval(() => setTime(new Date()), 1000);

    echo.channel('commandes')
      .listen('.nouvelle.commande', (e) => {
        // Double bip
        try {
          const ctx = new (window.AudioContext || window.webkitAudioContext)();
          const osc1 = ctx.createOscillator();
          const gain1 = ctx.createGain();
          osc1.connect(gain1);
          gain1.connect(ctx.destination);
          osc1.frequency.value = 880;
          osc1.type = 'sine';
          gain1.gain.setValueAtTime(0.4, ctx.currentTime);
          gain1.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
          osc1.start(ctx.currentTime);
          osc1.stop(ctx.currentTime + 0.3);
          const osc2 = ctx.createOscillator();
          const gain2 = ctx.createGain();
          osc2.connect(gain2);
          gain2.connect(ctx.destination);
          osc2.frequency.value = 1100;
          osc2.type = 'sine';
          gain2.gain.setValueAtTime(0.4, ctx.currentTime + 0.35);
          gain2.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.65);
          osc2.start(ctx.currentTime + 0.35);
          osc2.stop(ctx.currentTime + 0.65);
        } catch(e) {}

        if (Notification.permission === 'granted') {
          new Notification('Nouvelle commande VAH\'INN', {
            body: 'Une nouvelle commande vient d\'arriver !',
            icon: '/favicon.ico'
          });
        }

        chargerCommandes();
      });
    // Demande permission notifications
    if (Notification.permission === 'default') {
      Notification.requestPermission();
    }

    return () => {
      clearInterval(interval);
      clearInterval(clock);
      echo.leaveChannel('commandes');
    };
  }, []);

  const changerStatut = async (id, statut) => {
    await api.put('/commandes/' + id + '/statut', { statut });
    chargerCommandes();
  };

  const getTemps = (created_at) => {
    const diff = Math.floor((new Date() - new Date(created_at)) / 60000);
    if (diff < 1) return '< 1 min';
    return diff + ' min';
  };

  const getTempsColor = (created_at) => {
    const diff = Math.floor((new Date() - new Date(created_at)) / 60000);
    if (diff < 10) return '#22c55e';
    if (diff < 20) return '#f59e0b';
    return '#ef4444';
  };

  const commandesActives = commandes.filter(c => ['en_attente', 'en_cuisine'].includes(c.statut));
  const commandesPrêtes = commandes.filter(c => c.statut === 'pret');

  if (loading) return (
    <div style={styles.loadingScreen}>
      <div style={styles.loadingLogo}>VAH'INN</div>
      <div style={styles.loadingSub}>Cuisine</div>
    </div>
  );

  return (
    <div style={styles.app}>
      <style>{globalStyles}</style>

      {/* HEADER */}
      <header style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.logo}>VAH'INN</div>
          <div style={styles.logoSub}>Cuisine</div>
        </div>
        <div style={styles.headerCenter}>
          <div style={styles.clock}>
            {time.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>
        <div style={styles.headerRight}>
          <div style={styles.badge}>
            <span style={styles.badgeDot}></span>
            {commandesActives.length} en attente
          </div>
          <button style={styles.logoutBtn} onClick={logout}>⏻</button>
        </div>
      </header>

      {/* COMMANDES EN COURS */}
      <div style={styles.section}>
        <div style={styles.sectionHeader}>
          <div style={styles.sectionLine}></div>
          <span style={styles.sectionTitle}>Commandes en cours</span>
          <div style={styles.sectionLine}></div>
        </div>

        {commandesActives.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={styles.emptyIcon}>🍽️</div>
            <div style={styles.emptyText}>Aucune commande en attente</div>
          </div>
        ) : (
          <div style={styles.cardsGrid}>
            {commandesActives.map((commande) => (
              <div
                key={commande.id}
                style={{
                  ...styles.card,
                  ...(commande.statut === 'en_cuisine' ? styles.cardEnCuisine : styles.cardEnAttente)
                }}
              >
                {/* Card Header */}
                <div style={styles.cardHeader}>
                  <div style={styles.tableInfo}>
                    <span style={styles.tableNum}>{commande.table?.numero}</span>
                    <span style={styles.tableZone}>{commande.table?.zone?.nom}</span>
                  </div>
                  <div style={styles.cardMeta}>
                    <div style={{...styles.tempsTag, color: getTempsColor(commande.created_at)}}>
                      ⏱ {getTemps(commande.created_at)}
                    </div>
                    <div style={styles.serveurTag}>{commande.serveur}</div>
                  </div>
                </div>

                {/* Statut badge */}
                <div style={{
                  ...styles.statutBadge,
                  ...(commande.statut === 'en_cuisine' ? styles.statutEnCuisine : styles.statutEnAttente)
                }}>
                  {commande.statut === 'en_cuisine' ? '👨‍🍳 En préparation' : '⏳ Nouveau'}
                </div>

                {/* Articles */}
                <div style={styles.articlesList}>
                  {commande.lignes?.map((ligne) => (
  <div key={ligne.id} style={styles.articleRow}>
    <div style={styles.articleQte}>{ligne.quantite}</div>
    <div style={{display:'flex', flexDirection:'column', gap:'2px'}}>
      <div style={styles.articleNom}>{ligne.article?.nom}</div>
      {ligne.note && (
        <div style={{
          fontSize: '12px',
          color: '#a5b4fc',
          fontStyle: 'italic',
          paddingLeft: '4px',
          borderLeft: '2px solid rgba(165,180,252,0.4)',
        }}>
          {ligne.note}
        </div>
      )}
    </div>
  </div>
))}
                </div>

                {/* Note */}
                {commande.note && (
                  <div style={styles.noteBox}>
                    📝 {commande.note}
                  </div>
                )}

                {/* Bouton action */}
                <div style={styles.cardFooter}>
                  {commande.statut === 'en_attente' && (
                    <button
                      style={styles.btnCuisine}
                      onClick={() => changerStatut(commande.id, 'en_cuisine')}
                    >
                      👨‍🍳 Commencer
                    </button>
                  )}
                  {commande.statut === 'en_cuisine' && (
                    <button
                      style={styles.btnPret}
                      onClick={() => changerStatut(commande.id, 'pret')}
                    >
                      ✅ Prêt à servir
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* COMMANDES PRÊTES */}
      {commandesPrêtes.length > 0 && (
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionLine}></div>
            <span style={{...styles.sectionTitle, color: '#22c55e'}}>Prêtes à servir</span>
            <div style={styles.sectionLine}></div>
          </div>
          <div style={styles.prêtesGrid}>
            {commandesPrêtes.map((commande) => (
              <div key={commande.id} style={styles.cardPrete}>
                <span style={styles.preteTable}>{commande.table?.numero}</span>
                <span style={styles.preteZone}>{commande.table?.zone?.nom}</span>
                <span style={styles.preteCheck}>✓</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const globalStyles = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #0a0f1e; }
  button:active { transform: scale(0.96) !important; }
`;

const styles = {
  app: {
    minHeight: '100vh',
    background: 'linear-gradient(160deg, #0a0f1e 0%, #0f172a 50%, #0a0f1e 100%)',
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    color: '#e2e8f0',
    paddingBottom: '24px',
  },
  loadingScreen: {
    minHeight: '100vh',
    background: '#0a0f1e',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  loadingLogo: {
    fontSize: '42px',
    fontWeight: '900',
    letterSpacing: '8px',
    color: '#f59e0b',
  },
  loadingSub: {
    fontSize: '14px',
    letterSpacing: '4px',
    color: '#64748b',
    textTransform: 'uppercase',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 20px',
    background: 'rgba(15, 23, 42, 0.95)',
    borderBottom: '1px solid rgba(245, 158, 11, 0.2)',
  },
  headerLeft: { display: 'flex', flexDirection: 'column' },
  logo: {
    fontSize: '20px',
    fontWeight: '900',
    letterSpacing: '4px',
    color: '#f59e0b',
    lineHeight: 1,
  },
  logoSub: {
    fontSize: '10px',
    letterSpacing: '3px',
    color: '#64748b',
    textTransform: 'uppercase',
  },
  headerCenter: { textAlign: 'center' },
  clock: {
    fontSize: '26px',
    fontWeight: '700',
    color: '#f1f5f9',
    letterSpacing: '2px',
  },
  headerRight: { display: 'flex', alignItems: 'center', gap: '12px' },
  badge: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: 'rgba(239, 68, 68, 0.15)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    color: '#ef4444',
    padding: '6px 14px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '600',
  },
  badgeDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: '#ef4444',
    display: 'inline-block',
    animation: 'pulse 2s infinite',
  },
  logoutBtn: {
    background: 'rgba(239, 68, 68, 0.15)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    color: '#ef4444',
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    fontSize: '18px',
    cursor: 'pointer',
  },
  section: { padding: '16px' },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '14px',
  },
  sectionLine: {
    flex: 1,
    height: '1px',
    background: 'linear-gradient(90deg, transparent, rgba(245, 158, 11, 0.3), transparent)',
  },
  sectionTitle: {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    color: '#64748b',
    whiteSpace: 'nowrap',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px',
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '20px',
    border: '1px solid rgba(51, 65, 85, 0.4)',
    gap: '12px',
  },
  emptyIcon: { fontSize: '48px' },
  emptyText: { fontSize: '16px', color: '#475569' },
  cardsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '14px',
  },
  card: {
    borderRadius: '20px',
    padding: '18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    border: '1px solid',
    transition: 'transform 0.2s',
  },
  cardEnAttente: {
    background: 'linear-gradient(145deg, #1a0a0a, #2d1515)',
    borderColor: 'rgba(239, 68, 68, 0.4)',
    boxShadow: '0 4px 24px rgba(239, 68, 68, 0.1)',
  },
  cardEnCuisine: {
    background: 'linear-gradient(145deg, #1a120a, #2d1f0a)',
    borderColor: 'rgba(245, 158, 11, 0.4)',
    boxShadow: '0 4px 24px rgba(245, 158, 11, 0.1)',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  tableInfo: { display: 'flex', flexDirection: 'column', gap: '2px' },
  tableNum: {
    fontSize: '36px',
    fontWeight: '900',
    color: '#f1f5f9',
    lineHeight: 1,
  },
  tableZone: {
    fontSize: '12px',
    color: '#64748b',
    letterSpacing: '1px',
  },
  cardMeta: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' },
  tempsTag: {
    fontSize: '18px',
    fontWeight: '700',
  },
  serveurTag: {
    fontSize: '11px',
    color: '#475569',
  },
  statutBadge: {
    padding: '6px 14px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.5px',
    textAlign: 'center',
  },
  statutEnAttente: {
    background: 'rgba(239, 68, 68, 0.15)',
    color: '#fca5a5',
    border: '1px solid rgba(239, 68, 68, 0.3)',
  },
  statutEnCuisine: {
    background: 'rgba(245, 158, 11, 0.15)',
    color: '#fde68a',
    border: '1px solid rgba(245, 158, 11, 0.3)',
  },
  articlesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '12px',
    background: 'rgba(0,0,0,0.2)',
    borderRadius: '12px',
  },
  articleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
  },
  articleQte: {
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    background: 'rgba(245, 158, 11, 0.2)',
    border: '1px solid rgba(245, 158, 11, 0.4)',
    color: '#f59e0b',
    fontSize: '20px',
    fontWeight: '900',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  articleNom: {
    fontSize: '15px',
    fontWeight: '500',
    color: '#e2e8f0',
    lineHeight: 1.3,
  },
  noteBox: {
    padding: '10px 14px',
    background: 'rgba(245, 158, 11, 0.1)',
    border: '1px solid rgba(245, 158, 11, 0.2)',
    borderRadius: '10px',
    fontSize: '13px',
    color: '#fde68a',
  },
  cardFooter: { marginTop: '4px' },
  btnCuisine: {
    width: '100%',
    padding: '14px',
    borderRadius: '12px',
    border: 'none',
    background: 'linear-gradient(135deg, #d97706, #b45309)',
    color: '#fff',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer',
    letterSpacing: '0.5px',
  },
  btnPret: {
    width: '100%',
    padding: '14px',
    borderRadius: '12px',
    border: 'none',
    background: 'linear-gradient(135deg, #16a34a, #15803d)',
    color: '#fff',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer',
    letterSpacing: '0.5px',
  },
  prêtesGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
  },
  cardPrete: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 20px',
    background: 'rgba(22, 163, 74, 0.1)',
    border: '1px solid rgba(22, 163, 74, 0.3)',
    borderRadius: '14px',
  },
  preteTable: {
    fontSize: '22px',
    fontWeight: '800',
    color: '#f1f5f9',
  },
  preteZone: {
    fontSize: '12px',
    color: '#64748b',
  },
  preteCheck: {
    fontSize: '20px',
    color: '#22c55e',
    fontWeight: '700',
  },
};
